import axios from 'axios'
import pageKeys from '../common/pagekeys'
import store from '@/store'

export default {
    async getCuttOffSummary() {
        try {          
            const response = await axios.get(`AttendanceUpload/cutoff-summary`,
            {
                headers: {
                    'page_key': pageKeys.attendance_upload 
                }
            })                                                           
            return response
        } catch (error) {
            console.log('AttendanceUpload api getCuttOffSummary error')
            throw error
        }
    },  
    async dowloadTemplate(cutOffId) {
        try
        {            
            const response = await axios.get(`AttendanceUpload/${store.state.selectedTeamId}/template/${cutOffId}`, {
                responseType: 'arraybuffer',
                headers: {
                    'page_key': pageKeys.attendance_upload
                }
            })            
            return response
        }
        catch (error)
        {
            console.log('AttendanceUpload api dowloadTemplate error')
            throw error
        }
    },
    async getUploaded(cutOffId) {
        try {          
            const response = await axios.get(`AttendanceUpload/${store.state.selectedTeamId}/${cutOffId}`,
            {
                headers: {
                    'page_key': pageKeys.attendance_upload 
                }
            })                                                           
            return response
        } catch (error) {
            console.log('AttendanceUpload api getUploaded error')
            throw error
        }
    },  
    async save(cutOffId) {
        try {          
            const response = await axios.post(`AttendanceUpload/${store.state.selectedTeamId}/save/${cutOffId}`,
            {},
            {
                headers: {
                    'page_key': pageKeys.attendance_upload 
                }
            })                                                           
            return response
        } catch (error) {
            console.log('AttendanceUpload api save error')
            throw error
        }
    },  
}